import React from 'react';
import { Heading } from '../../Form';
import Input from '../../Input';
import ReactSelect from 'react-select';
import { variables } from 'src/Tenants';

interface ManagerOption {
  value: string;
  label: string;
}

interface PropertyBasicsSectionProps {
  name: string;
  propertyManagerId?: string;
  propertyManager?: { id?: string };
  errors: { name?: string };
  filteredPropertyManagers: any[];
  onChange: (update: any) => void;
  showHeading?: boolean;
}

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const selectStyles = {
  singleValue: (base: any) => ({ ...base, textAlign: 'left' as const }),
  placeholder: (base: any) => ({ ...base, textAlign: 'left' as const }),
  input: (base: any) => ({ ...base, textAlign: 'left' as const }),
  option: (base: any) => ({ ...base, textAlign: 'left' as const }),
};

const toManagerOption = (manager: any): ManagerOption => ({
  value: manager.id,
  label: `${manager.firstname} ${manager.lastname}`,
});

const resolvePropertyManagerValue = (
  propertyManagerId?: string,
  propertyManager?: { id?: string }
): string => {
  if (propertyManagerId && propertyManagerId !== EMPTY_GUID) {
    return propertyManagerId;
  }

  return propertyManager?.id ?? '';
};

const PropertyBasicsSection = ({
  name,
  propertyManagerId,
  propertyManager,
  errors,
  filteredPropertyManagers,
  onChange,
  showHeading = true,
}: PropertyBasicsSectionProps) => {
  const selectedPropertyManagerId: string = resolvePropertyManagerValue(
    propertyManagerId,
    propertyManager
  );

  const propertyManagerOptions: ManagerOption[] =
    filteredPropertyManagers.map(toManagerOption);

  const selectedPropertyManagerOption: ManagerOption | null =
    propertyManagerOptions.find(
      (option: ManagerOption) => option.value === selectedPropertyManagerId
    ) ?? null;

  return (
    <>
      {showHeading && <Heading>Property Details</Heading>}
      <Input
        value={name}
        onChange={(e: any) => onChange({ name: e.target.value })}
        label="Property Name"
        required
        placeholder="eg., Example Property"
        block
        errors={errors.name}
      />
      <div style={{ marginBottom: '2rem' }}>
        <label className="input__label" style={{ marginBottom: '0.5rem' }}>
          {variables.propertyDeveloper}
          <span className="input__required" />
        </label>
        <ReactSelect
          value={selectedPropertyManagerOption}
          placeholder={`Select ${variables.propertyDeveloper}`}
          onChange={(selected: any) => {
            onChange({
              propertyManagerId: selected?.value ?? '',
              propertyManager: {},
            });
          }}
          options={propertyManagerOptions}
          isClearable
          styles={selectStyles}
        />
      </div>
    </>
  );
};

export default PropertyBasicsSection;
